import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";

export const getApproverHighestTier = (dispatch, site, tierId) => {
  AsyncCallHandler(
    NEXUS_CONST.GET_APPROVER_HIGHEST_TIER + site + "&tierlevel=1",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_APPROVER_HIGHEST_TIER,
      payload: res.data,
    });
  });
};

export const fetchUsers = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_PEOPLE + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_PEOPLE, payload: res.data });
    }
  );
};

export const saveRPS = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_RPS, NEXUS_CONST.POST, data).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.MANAGE_RPS, payload: res.data });
    }
  );
};

export const fetchReasonCodeByFrequency = (dispatch, props) => {
  AsyncCallHandler(
    NEXUS_CONST.GET_REASON_CODE_BY_FREQUENCY + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_REASON_CODE_BY_FREQUENCY,
      payload: res.data,
    });
  });
};

export const fetchSolutionData = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_SOLUTION_DATA + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_SOLUTION_DATA, payload: res.data });
    }
  );
};

export const deleteSolutionData = (dispatch, id, rpsId) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_SOLUTION_DATA + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchSolutionData(dispatch, rpsId);
  });
};

export const fetchRPSRail = (dispatch, rpsId) => {
  AsyncCallHandler(NEXUS_CONST.GET_RPS_RAIL + rpsId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_RPS_RAIL, payload: res.data });
    }
  );
};

export const saveRPSRAIL = (dispatch, data, rpsID) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_RPSRAIL, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchRPSRail(dispatch, rpsID);
    }
  );
};

export const saveSolutionData = (dispatch, data, rpsID) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_SOLUTION_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchSolutionData(dispatch, rpsID);
  });
};

export const updateRPSRAIL = (dispatch, data, rpsID) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_RPSRAIL, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchRPSRail(dispatch, rpsID);
    }
  );
};

export const saveAttachment = (dispatch, data, props) => {
  AsyncCallHandler(
    NEXUS_CONST.RPS_ATTACHMENT + props,
    NEXUS_CONST.PUT,
    data
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.RPS_ATTACHMENT, payload: res.data });
    //fetchRPSRail(dispatch, rpsID)
  });
};
export const fetchRPSGridData = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_RPS_GRID + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_RPS_GRID, payload: res.data });
    }
  );
};

export const fetchTiersList = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_TIER_LIST + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_TIER_LIST, payload: res.data });
    }
  );
};

export const deleteRPSData = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_RPS_DATA + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchRPSGridData(dispatch, tier);
    }
  );
};

export const fetchOphData = (dispatch, props) => {
  AsyncCallHandler(
    "digitaltier/getParetoData?siteid=" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.GET_OPH_FILE, payload: res.data });
  });
};

export const downloadOphFile = (name, url, inputData = null) => {
  AsyncCallHandler(url, NEXUS_CONST.POST, inputData, NEXUS_CONST.BLOB).then(
    (res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    }
  );
};

export const exportData = (url, name, inputData = null) => {
  AsyncCallHandler(url, NEXUS_CONST.POST, inputData, NEXUS_CONST.BLOB).then(
    (res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }
  );
};

export const fetchPeopleList = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.GET_PEOPLE_DATA + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_PEOPLE_DATA, payload: res.data });
    }
  );
};

export const fetchPSData = (dispatch, psId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_PS_DATA + psId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_PS_DATA, payload: res.data });
    }
  );
};

export const updateRcaDataGrid = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.POST_RPS_GRID_DATA, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchRCAGridData(dispatch, tier);
    }
  );
};
export const saveProblemSolving = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_PS_DATA, NEXUS_CONST.POST, data).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.MANAGE_RPS, payload: res.data });
    }
  );
};

export const fetchRCAGridData = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_RCA_GRID + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_RCA_GRID, payload: res.data });
    }
  );
};

export const fetchProblemSovingDatabyId = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_ALL_RPS_DATA + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_ALL_RPS_DATA, payload: res.data });
    }
  );
};

export const add_updateRcaBoxFour = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.POST_ALL_RPS_DATA, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchProblemSovingDatabyId(dispatch, tier);
    }
  );
};

export const putRcaFileData = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.RCA_ATTACHMENT, NEXUS_CONST.PUT, data).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.RCA_ATTACHMENT, payload: res.data });
      //fetchRPSRail(dispatch, rpsID)
    }
  );
};
export const saveConfirmResultsGridData = (dispatch, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.ADD_CONFIRM_RESULT + tier,
    NEXUS_CONST.POST
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.POST_CONFIRMRESULTS_GRID,
      payload: res.data,
    });
  });
};

export const fetchConfirmResultGridData = (dispatch, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_CONFIRMRESULT_GRID + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_CR_DATA,
      payload: res.data,
    });
  });
};

export const deleteRcaDataGrid = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_RCAGRID_DATA + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchRCAGridData(dispatch, tier);
    }
  );
};

export const putConfirmResultsFileData = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.PUT_CONFIRMRESULT_ATTACHMENT,
    NEXUS_CONST.PUT,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.PUT_CONFIRMRESULT_ATTACHMENT,
      payload: res.data,
    });
    //fetchRPSRail(dispatch, rpsID)
  });
};

export const resultsGetAttachmentsData = (dispatch, tier, props) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_CONFIRMRESULT_ATTACHMENT +
      tier +
      "&attachmentType=Result",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_RESULTS_ATTACHMENT_DATA,
      payload: res.data,
    });
  });
};
export const breakdownGetAttachmentsData = (dispatch, tier, props) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_CONFIRMRESULT_ATTACHMENT +
      tier +
      "&attachmentType=Breakdown",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_BREAKDOWN_ATTACHMENT_DATA,
      payload: res.data,
    });
  });
};
export const rcaGetAttachmentsData = (dispatch, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_RCA_ATTACHMENT +
      tier +
      "&attachmentType=RootCauseAnalysis",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_RCA_ATTACHMENT_DATA,
      payload: res.data,
    });
  });
};

export const deleteRcaFileAttachment = (dispatch, id, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_ATTACHMENT_DATA + id,
    NEXUS_CONST.POST
  ).then((res) => {
    rcaGetAttachmentsData(dispatch, tier);
  });
};

export const deleteResultsFileAttachment = (
  dispatch,
  id,
  tierId,
  siteId,
  section,
  tier
) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_RESULTS_ATTACHMENT_DATA +
      id +
      "&tierId=" +
      tierId +
      "&siteId=" +
      siteId +
      "&section=" +
      section,
    NEXUS_CONST.POST
  ).then((res) => {
    resultsGetAttachmentsData(dispatch, tier);
  });
};

export const fetchSpsInfo = (dispatch, psId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_PS_DATA + psId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_PS_DATA, payload: res.data });
    }
  );
};

export const fetchRapidExperimentGridData = (dispatch, rpsID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_RAPID_EXPERIMENT + rpsID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_RAPID_EXPERIMENT,
      payload: res.data,
    });
  });
};

export const saveExperiment = (dispatch, data, rpsID) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_EXPERIMENT, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchRapidExperimentGridData(dispatch, rpsID);
    }
  );
};

export const experimentGetAttachmentsData = (dispatch, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_Experiment_ATTACHMENT +
      tier +
      "&attachmentType=Experiment",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_Experiment_ATTACHMENT,
      payload: res.data,
    });
  });
};

export const deleteExperiment = (dispatch, id, rpsID) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_EXPERIMENT + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchRapidExperimentGridData(dispatch, rpsID);
    }
  );
};

export const deleteFileAttachment = (dispatch, id, rpsID) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_EXPERIMENT + id, NEXUS_CONST.POST).then(
    (res) => {
      experimentGetAttachmentsData(dispatch, rpsID);
    }
  );
};

export const fetchPrintInfo = (dispatch, id) => {
  AsyncCallHandler(
    "ProblemSolving/getPrintProblemSolvingData?rpsId=" + id,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_PRINT_DATA", payload: res.data });
  });
};

export const fetchSPSWB = (dispatch, id) => {
  AsyncCallHandler(
    "ProblemSolving/getSPSWhiteboardData?id=" + id,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_SPSWB_DATA", payload: res.data });
  });
};

export const fetchUserPref = (dispatch, props) => {
  AsyncCallHandler(
    "Home/getGridCustomization?tierid" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "USER_PREF_SPS", payload: res.data });
  });
};

export const updateUserPref = (dispatch, data) => {
  AsyncCallHandler("Home/ManageGridCustomData", NEXUS_CONST.POST, data).then(
    (res) => {
      //data saved!
    }
  );
};

export const fetchCommonParetoData = (dispatch, props) => {
  AsyncCallHandler(
    "commonUtility/getCommonParetoData?siteid=" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.GET_OPH_FILE, payload: res.data });
  });
};

export const fetchModuleData = (dispatch, props) => {
  AsyncCallHandler(NEXUS_CONST.GET_MODULE_DATA + props, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({
        type: ACTION_TYPES.GET_MODULE_DATA,
        payload: res.data,
      });
    }
  );
};

export const fetchReasonCodeFrequencyByModule = (dispatch, props) => {
  AsyncCallHandler(
    NEXUS_CONST.GET_REASON_CODE_FREQUENCY_BY_MODULE + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_REASON_CODE_FREQUENCY_BY_MODULE,
      payload: res.data,
    });
  });
};
